<section class="utility-page">
  <div class="page-shell">
    <a routerLink="/register" class="crumb">Select Stakeholder <span>›</span> Utility Registration</a>

    <header class="hero">
      <div class="hero-left">
        <button type="button" class="back-btn" routerLink="/register">←</button>
        <div>
          <h1>Utility Registration</h1>
          <p>DISCOM / Trader - Fill in all required fields and submit. Your request will be sent to MSLDC Admin for approval.</p>
        </div>
      </div>
      <div class="hero-pill">No login required</div>
    </header>

    <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
      <section class="panel">
        <div class="panel-head">Utility Information</div>
        <div class="grid two">
          <label>
            <span>Utility Name *</span>
            <input formControlName="utility_name" placeholder="e.g. MSEDCL - Pune Zone">
          </label>
          <label>
            <span>Utility Category *</span>
            <select formControlName="utility_category">
              <option value="">Select Category</option>
              <option>DISCOM</option>
              <option>Trader</option>
              <option>Open Access</option>
            </select>
          </label>
          <label>
            <span>Buyer Type *</span>
            <select formControlName="buyer_type">
              <option value="">Select Buyer Type</option>
              <option>Bulk</option>
              <option>Industrial</option>
              <option>Commercial</option>
            </select>
          </label>
          <label>
            <span>License Number *</span>
            <input formControlName="license_number" placeholder="e.g. MERC/L/2024/001">
          </label>
          <label>
            <span>Peak Demand (MW) *</span>
            <input formControlName="peak_demand_mw" placeholder="e.g. 4500">
          </label>
          <label>
            <span>Loss Percentage (%) *</span>
            <input formControlName="loss_percentage" placeholder="e.g. 8.50">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Utility Office Address</div>
        <div class="grid two">
          <label class="span-2">
            <span>Address Line 1 *</span>
            <input formControlName="address_line1" placeholder="Building / Plot No., Street">
          </label>
          <label>
            <span>Address Line 2</span>
            <input formControlName="address_line2" placeholder="Area / Locality">
          </label>
          <label>
            <span>City / Town *</span>
            <input formControlName="city_town" placeholder="e.g. Pune">
          </label>
          <label>
            <span>District *</span>
            <input formControlName="district" placeholder="Select District">
          </label>
          <label>
            <span>State *</span>
            <input formControlName="state" placeholder="Select State">
          </label>
          <label>
            <span>Pin Code *</span>
            <input formControlName="pin_code" placeholder="e.g. 411001">
          </label>
          <label>
            <span>Country *</span>
            <input formControlName="country" placeholder="India">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Nodal Officer Details</div>
        <div class="grid two">
          <label>
            <span>Full Name *</span>
            <input formControlName="contact_person_name" placeholder="Nodal Officer Name">
          </label>
          <label>
            <span>Designation</span>
            <input formControlName="designation" placeholder="e.g. Manager - Grid Operations">
          </label>
          <label>
            <span>Mobile Number *</span>
            <input formControlName="mobile_number" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Email Address *</span>
            <input formControlName="email_address" placeholder="nodal@company.com" type="email">
          </label>
          <label>
            <span>Alternate Mobile</span>
            <input formControlName="alternate_mobile" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Alternate Email</span>
            <input formControlName="alternate_email" placeholder="alternate@company.com">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Document Upload</div>
        <div class="upload-list">
          @for (document of documents; track document) {
            <div class="upload-card">
              <span class="upload-title">{{ document }} *</span>
              <div class="upload-box">
                <div class="upload-icon">⇪</div>
                <p>Drop files here or <strong>browse</strong></p>
                <small>PDF, JPG, PNG up to 10 MB each</small>
              </div>
            </div>
          }
        </div>
      </section>

      <section class="panel declaration-panel">
        <div class="panel-head">Declaration</div>
        <div class="declaration">
          <p>
            I hereby declare that the information furnished above is true and correct to the best of my knowledge and belief.
            I understand that in the event of any information being found false or incorrect, my registration is liable to be
            cancelled without any notice.
          </p>
        </div>
        <label class="terms">
          <input type="checkbox" formControlName="declaration_accept">
          <span>I agree to the <strong>Terms & Conditions</strong> and <strong>Privacy Policy</strong> of the RE-DSM system.</span>
        </label>
      </section>

      @if (message) {
        <p class="message">{{ message }}</p>
      }

      <footer class="footer-actions">
        <div class="note">Fields marked * are mandatory. Your registration request will be sent to the MSLDC Admin for review. No login is required to submit.</div>
        <div class="actions">
          <a routerLink="/register" class="btn ghost">Cancel</a>
          <button type="button" class="btn ghost">Reset</button>
          <button type="submit" class="btn primary">Send Request to Admin</button>
        </div>
      </footer>
    </form>
  </div>
</section>
